export default __webpack_public_path__ + "resources/icons/d231-e668.png";